import React from "react";
import { Link } from "react-router-dom";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-page" className="min-h-[60vh] grid place-items-center px-4 py-14">
      <div className="w-full max-w-lg bg-[#FFFDF9] sacred-border rounded-3xl p-10 text-center">
        <div className="overline">Payment cancelled</div>
        <h1 className="font-serif text-4xl text-[#4A0E17] mt-2">No offering was taken</h1>
        <p className="text-[#63534E] mt-4">Whenever you're ready, your seva will be waiting at the altar.</p>
        <div className="mt-8 flex gap-3 justify-center">
          <Link to="/donate" data-testid="try-again" className="btn-saffron">Try again</Link>
          <Link to="/" data-testid="back-home" className="btn-ghost-gold">Return home</Link>
        </div>
      </div>
    </div>
  );
}
